import React, {Component} from 'react';
import {withStyles} from '@material-ui/core/styles';
import Fab from '@material-ui/core/Fab';
import AddIcon from '@material-ui/icons/Add';
import SearchCanvasUsers from './SearchCanvasUsers';

import {connect} from 'react-redux';
import {actions} from '../../actions';

const styles = theme => ({
    root: {
        width: '100%',
        marginTop: '10px',
        overflowX: 'auto',
    },
    table: {
        // minWidth: 700,
    }
});

class AddCanvasUsers extends Component {
    onUserSelection = (selectedCanvasUser) => {
        // add to redux store
        this.props.addReviewer(selectedCanvasUser);
        // remove user from canvasUsers in redux store
        this.props.removeCanvasUser(selectedCanvasUser);
    };

    filterCanvasUsers = (users) => {
        return users.filter(canvasUser => !this.props.reviewers.find(reviewer => (reviewer.unid === canvasUser.unid)));
    };

    render() {
        return (
            <SearchCanvasUsers
                onUserSelection={this.onUserSelection}
                filterCanvasUsers={this.filterCanvasUsers}
                canvasUsers={this.props.canvasUsers}
                addCanvasUser={this.props.addCanvasUser}
                resetCanvasUsers={this.props.resetCanvasUsers}
            >
                <Fab size="small" color="secondary" aria-label="Add"
                     className={this.props.classes.margin}>
                    <AddIcon/>
                </Fab>
            </SearchCanvasUsers>
        );
    }
}

function mapStateToProps(state) {
    return {
        reviewers: state.reviewers,
        canvasUsers: state.canvasUsers
    }
}

export default connect(mapStateToProps, actions)(withStyles(styles)(AddCanvasUsers));
